@if (position) {
  <h3 mat-dialog-title>Edit: {{ position.title }}</h3>
} @else {
  <h3 mat-dialog-title>Create New Position</h3>
}
<mat-dialog-content>
  <form [formGroup]="positionForm" fxLayout="column">
    <div fxLayout="row" fxLayoutGap="5%">
      <mat-form-field appearance="outline" floatLabel="always" fxFlex="80%">
        <mat-label>Position Title</mat-label>
        <input
          matInput
          forbidAngleBrackets
          type="text"
          formControlName="title"
        />
        @if (positionForm.controls.title.hasError('notEmpty')) {
          <mat-error>
            {{ positionForm.controls.title.getError('notEmpty') }}
          </mat-error>
        }
        @if (positionForm.controls.title.hasError('noPipe')) {
          <mat-error>
            {{ positionForm.controls.title.getError('noPipe') }}
          </mat-error>
        }
      </mat-form-field>
      <mat-form-field appearance="outline" floatLabel="always" fxFlex="15%">
        <mat-label>Seats</mat-label>
        <input matInput type="number" formControlName="seatCount" />
      </mat-form-field>
    </div>

    <mat-form-field
      fxFlex="100%"
      appearance="outline"
      floatLabel="always"
      fxFlex="100%"
      class="mat-body-2"
    >
      <mat-label>Position Description</mat-label>
      <textarea
        matInput
        forbidAngleBrackets
        matTextareaAutosize
        matAutosizeMinRows="2"
        matAutosizeMaxRows="10"
        type="text"
        formControlName="description"
      ></textarea>
      @if (positionForm.controls.description.hasError('maxlength')) {
        <mat-error> Description has a maximum of 500 characters </mat-error>
      }
    </mat-form-field>

    <mat-checkbox
      color="primary"
      formControlName="arePeopleSyncedToTeamManager"
    >
      People assigned to this position become the primary contacts and receive
      team communication emails.
    </mat-checkbox>
  </form>

  @if (isStaff) {
    <div class="eligibility-requirements">
      <h4 class="eligibility-title">Eligibility Requirements</h4>
      <p class="eligibility-description mat-body-2">
        Define the criteria a person should meet to hold a seat in this position.
        A warning appears on the seat card when a seated person doesn't meet them.
      </p>
      <app-admin-automation-odata-filter
        [filterService]="peopleFilterService"
        [appliedFilters]="appliedFilters"
        [allowedFilterGroups]="allowedFilterGroups"
        [allowedFilterDisplayNames]="allowedFilterDisplayNames"
      >
      </app-admin-automation-odata-filter>
    </div>
  }
</mat-dialog-content>
<mat-dialog-actions>
  @if (position) {
    <button
      mat-flat-button
      color="primary"
      (click)="savePosition()"
      [disabled]="!positionForm.valid"
    >
      Update
    </button>
  } @else {
    <button
      mat-flat-button
      color="primary"
      (click)="createPosition()"
      [disabled]="!positionForm.valid"
    >
      Create Position
    </button>
  }

  <button type="button" mat-stroked-button (click)="dialogRef.close('no')">
    Cancel
  </button>
</mat-dialog-actions>
